import React, {useCallback, useEffect, useState} from 'react';
import {format} from 'date-fns';
import {isEmpty} from 'lodash';

import DashboardView from './DashboardView';
import SheetsRadioGroup from './SheetsRadioGroup';

const formatDateToPar = (date) => format(date, 'yy-MM-dd');

const tranformData = (info) =>
    info.type === 'Array' ? [info.defaultValue] : info.defaultValue;

const createExtraParameter = (extraProperties) =>
    extraProperties ?
        Object.keys(extraProperties).reduce(
            (res, key) => ({...res, [key]: tranformData(extraProperties[key])}),
            {},
        ) :
        undefined;

const Dashboard = ({
    dashboard,
    startDate,
    endDate,
    selected,
    componentsMapper,
}) => {
    const [extraparms, setextraparms] = useState(
        createExtraParameter(dashboard && dashboard.extraProperties),
    );

    const [parameters, setparameters] = useState({
        ...extraparms,
        from: formatDateToPar(startDate || new Date()),
        to: formatDateToPar(endDate || new Date()),
    });
    const [options, setoptions] = useState();
    const [selectedSheet, setSelectedSheet] = useState();

    const changeSelect = useCallback(
        (val) => setextraparms({...extraparms, ...val}),
        [extraparms],
    );
    useEffect(() => {
        setparameters({
            ...extraparms,
            from: formatDateToPar(startDate || new Date()),
            to: formatDateToPar(endDate || new Date()),
        });
    }, [startDate, endDate, extraparms]);

    const retrieveSheets = useCallback(
        (values) => {
            !selectedSheet &&
        !!values &&
        values.length &&
        setSelectedSheet(values[0].sheetId);
            setoptions(values);
        },
        [selectedSheet],
    );

    return (
        <div className="dash-viewer">
            <div className="params">
                {dashboard &&
          dashboard.extraProperties &&
          Object.keys(dashboard.extraProperties).map((key, idx) => (
              <div key={`${key}_${idx}`}>
                  {!!componentsMapper[dashboard.extraProperties[key].component] &&
                React.createElement(
                    componentsMapper[dashboard.extraProperties[key].component],
                    {
                        ...dashboard.extraProperties[key],
                        name: key,
                        callBack: changeSelect,
                    },
                )}
              </div>
          ))}
                {options && options.length > 1 && (
                    <>
                        {dashboard && !isEmpty(dashboard.extraProperties) && (
                            <div className="divider" />
                        )}
                        <SheetsRadioGroup
                            options={options}
                            setSelectedSheet={setSelectedSheet}
                            selectedSheet={selectedSheet}
                        />
                    </>
                )}
            </div>
            <div className="dash">
                {dashboard && (
                    <DashboardView
                        dashUrl={dashboard.embedUrl}
                        parameters={parameters}
                        idDash={`dash_${dashboard.idDash}`}
                        retrieveSheets={retrieveSheets}
                        selectedSheetChanged={selectedSheet}
                        selected={selected}
                    />
                )}
            </div>
        </div>
    );
};

export default Dashboard;
